module.exports = __webpack_public_path__ + "media/images/flags/1x1/brb-831fb8acc08747004854cc65cb9d2069.svg";